import { z } from 'zod';

export const TalentSearchItemSchema = z.object({
  id: z.union([
    z.string(),
    z.object({
      start: z.number(),
      end: z.number().nullish(),
    }),
  ]),
  name: z.string(),
  checked: z.boolean(),
  originalIndex: z.number().nullish(),
});

export type TalentSearchItem = z.infer<typeof TalentSearchItemSchema>;
